<div #extAggAcctGrid class="ext-agg-acct-grid h-100 w-100">
  <hs-aggregate-account-list-grid
    [actualReconDate]="actualReconDate | async"
  ></hs-aggregate-account-list-grid>
</div>

<hs-resize-handle
  [elem2]="extSubAcctGrid"
  [elem1]="extAggAcctGrid"
  [direction]="resizeDirection"
  [initialResizeHandleState]="state?.resizeHandleState"
  (resizeFinished)="onResizeFinished($event)"
></hs-resize-handle>

<div #extSubAcctGrid class="ext-sub-acct-grid h-100 w-100">
  <hs-sub-account-list-grid
    (onLoadAccount)="setLoadedAccount($event)"
    [actualReconDate]="actualReconDate | async"
  ></hs-sub-account-list-grid>
</div>
